import { useRef } from "react";
import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import useOutsideClicked from "./useOutsideClicked";
import { FocusScope } from "@react-aria/focus";
import useMobileScreen from "./useMobileScreen";
import { useDispatch, useSelector } from "react-redux";
import { setWorkers } from "../Redux/companyReducer";
import { useTranslation } from "../hooks/useTranslation";

//workers DropdownCheckbox
function DropdownCheckbox({ allWorkers, closeDropdown, dropdownButtonRef }) {
    const wrapperRef = useRef(null);
    const [workersFiltered, setWorkersFiltered] = useState([])
    const [userInput, setUserInput] = useState("")
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const workers = useSelector((state) => state.company.workers)
    const itemsCount = useSelector((state) => state.cart.itemCount)

    useMobileScreen()
    useOutsideClicked(wrapperRef, dropdownButtonRef, closeDropdown);

    const handleEsc = (e) => { if (e.keyCode === 27) { closeDropdown() } }

    useEffect(() => {
        if (userInput.trim()) {
            setWorkersFiltered(allWorkers.filter(worker =>
                worker.workerFirstName.includes(userInput.trim()) || worker.workerLastName.includes(userInput.trim())))
        } else {
            setWorkersFiltered(allWorkers)
        }
    }, [userInput])

    const handleSelect = (event, worker) => {
        if (!worker) {
            if (!event.target.checked) {
                dispatch(setWorkers([]))
            } else {
                dispatch(setWorkers(workersFiltered))
            }
        } else {
            if (!event.target.checked) {
                dispatch(setWorkers(workers.filter((w) => w.workerId !== worker.workerId)))
            } else {
                dispatch(setWorkers([...workers, worker]))
            }
        }
    }

    const isChecked = (worker) => {
        return workers.some((w) => w.workerId === worker.workerId)
    }

    const isMaxAmount = (worker) => {
        return !isChecked(worker) && workers && workers.length === itemsCount
    }

    return (
        <>
            {
                useMobileScreen() ?
                    <Modal show={true} onHide={closeDropdown} className="modal-workers-select">
                        <Modal.Header closeButton>
                            <Modal.Title
                                role="heading"
                                aria-label={`${t("Choose")} ${itemsCount} ${t("Recipients")} ${t("FromTheList")}`}
                            >
                                {`${t("Choose")} ${itemsCount} ${t("Recipients")} ${t("FromTheList")}`}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <h6 aria-label={`${t("YouChose")} ${workers.length} ${t("Recipients")}`} className="mb-3">{t("YouChose") + " " + workers.length + " " + t("Recipients")}</h6>
                            <div className="search-worker">
                                <i> <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M13 13L19 19M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg></i>
                                <input type="text" aria-label={t("SearchRecipient")} onChange={e => setUserInput(e.target.value)} />
                            </div>
                            <Form>
                                <div className="checkbox-worker">
                                    <input type="checkbox" id='all' checked={workersFiltered.length == workers.length} onChange={(event) => handleSelect(event, null)} />
                                    <label htmlFor='all'>{t("SelectAll")}</label>
                                </div>
                                {
                                    workersFiltered.map((worker) => {
                                        return <div className="checkbox-worker" key={worker.workerId}>
                                            <input type="checkbox" id={worker.workerId} checked={isChecked(worker)} disabled={isMaxAmount(worker)} onChange={(event) => handleSelect(event, worker)} />
                                            <label htmlFor={worker.workerId}>{worker.workerFirstName} {worker.workerLastName}</label>
                                        </div>
                                    })
                                }
                            </Form>
                        </Modal.Body>
                    </Modal>
                    :
                    <FocusScope contain restoreFocus autoFocus>
                        <div role="dialog" ref={wrapperRef} className="dropdown-workers" onKeyDown={e => handleEsc(e)}>
                            <div className="d-flex justify-content-between dropdown-title">
                                <span
                                    role="heading"
                                    aria-label={`${t("Choose")} ${itemsCount} ${t("Recipients")} ${t("FromTheList")}`}
                                >
                                    {t("Choose")} {itemsCount} {t("Recipients")} {t("FromTheList")}
                                </span>
                            </div>
                            <h6 aria-label={`${t("YouChose")} ${workers.length} ${t("Recipients")}`} className="mb-3">{t("YouChose") + " " + workers.length + " " + t("Recipients")}</h6>

                            <div className="search-worker">
                                <i> <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M13 13L19 19M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg></i>
                                <input type="text" aria-label={t("SearchRecipient")} onChange={e => setUserInput(e.target.value)} />
                            </div>
                            <Form>
                                <div className="checkbox-worker">
                                    <input type="checkbox" id='all' checked={workersFiltered.length == workers.length} onChange={(event) => handleSelect(event, null)} />
                                    <label htmlFor='all'>{t('SelectAll')}</label>
                                </div>
                                {
                                    workersFiltered.map((worker) => {
                                        return <div className="checkbox-worker" key={worker.workerId}>
                                            <input type="checkbox" id={worker.workerId} checked={isChecked(worker)} disabled={isMaxAmount(worker)} onChange={(event) => handleSelect(event, worker)} />
                                            <label htmlFor={worker.workerId}>{worker.workerFirstName} {worker.workerLastName}</label>
                                        </div>
                                    })
                                }
                            </Form>
                        </div>
                    </FocusScope>
            }
        </>
    );
}

export default DropdownCheckbox;
